import React from 'react'
import { Translate } from 'next-translate'
import { companyName } from '@app/configs'

// todo: use on a benchmark page. Focus sole on the App across feature usage speeds.
export const IntroBenches = ({ t }: { t: Translate }) => {
  const vc = t('view-source')

  return (
    <section className='py-6 bg-gray-100 dark:bg-gray-900 border dark:border-gray-800 rounded-sm'>
      <div className='text-center'>
        <div className='py-2'>
          <h3 className='text-lg font-semibold'>{t('bench-title')}</h3>
          <p className='text-base'> {t('bench-d')}</p>
        </div>
        <ul className='grid grid-cols-3 pt-1 h-40 place-items-center'>
          <li className='flex flex-1 px-2 h-full'>
            <div className='flex flex-col h-full place-content-end'>
              <div className='py-1' aria-hidden='true'>
                <div className='text-base font-semibold'>453,614</div>
              </div>
              <div className='px-2 bg-gray-700 h-full w-20 rounded-t border-4 border-b-0 border-gray-700 dark:bg-gray-700'>
                <div className='sr-only'>
                  {t('bench-c', { company: companyName, count: '453,614' })}
                </div>
              </div>
            </div>
          </li>
          <li className='flex flex-1 px-2 h-full'>
            <div className='flex flex-col h-full place-content-end'>
              <div className='py-1' aria-hidden='true'>
                <div className='text-base font-semibold'>44</div>
              </div>
              <div className='px-2 bg-gray-700 h-[6px] w-20 rounded-t'>
                <div className='sr-only'>
                  {t('bench-c', { company: 'Pa11y', count: '44' })}
                </div>
              </div>
            </div>
          </li>
          <li className='flex flex-1 px-2 h-full'>
            <div className='flex flex-col h-full place-content-end'>
              <div className='py-1' aria-hidden='true'>
                <div className='text-base font-semibold'>33</div>
              </div>
              <div className='px-2 bg-gray-700 h-[5px] w-20 rounded-t'>
                <div className='sr-only'>
                  {t('bench-c', { company: 'Axe', count: '33' })}
                </div>
              </div>
            </div>
          </li>
        </ul>
        <div className='grid grid-cols-3 py-2 text-center'>
          <a
            href='https://github.com/a11ywatch/github-actions/blob/1bd028ce0d6b729a61133cbd81942d73c604660a/.github/workflows/bench-action.yml'
            target='_blank'
            rel='noreferrer'
            className='hover:ring'
            aria-label={t('source-d', { company: 'a11ywatch' })}
          >
            <div className='text-base font-medium'>a11ywatch</div>
            <div className='text-sm '>v0.8.7</div>
            <div className='text-xs '>{vc}</div>
          </a>
          <a
            href='https://github.com/a11ywatch/github-actions/blob/1bd028ce0d6b729a61133cbd81942d73c604660a/.github/workflows/bench-pa11y.yml'
            target='_blank'
            className='hover:ring'
            aria-label={t('source-d', { company: 'pa11y' })}
            rel='noreferrer'
          >
            <div className='text-base font-medium'>pa11y</div>
            <div className='text-sm'>v6.2.3</div>
            <div className='text-xs'>{vc}</div>
          </a>
          <a
            href='https://github.com/a11ywatch/github-actions/blob/1bd028ce0d6b729a61133cbd81942d73c604660a/.github/workflows/bench-axe.yml'
            target='_blank'
            className='hover:ring'
            aria-label={t('source-d', { company: 'axe' })}
            rel='noreferrer'
          >
            <div className='text-base font-medium'>axe</div>
            <div className='text-sm'>v4.4.3</div>
            <div className='text-xs'>{vc}</div>
          </a>
        </div>
      </div>
    </section>
  )
}
